<template>
  <div>
    <form v-on:submit.prevent="deactivateProgramContest()">
      <input
        class="btn btn-primary btn-lg btn-sm-block m-2"
        type="submit"
        :name="params.isActive === 1 ? 'deactivate' : 'activate'"
        :value="
          params.isActive === 1
            ? 'De-Activate This Program/Contest'
            : 'Re-Activate This Program/Contest'
        "
      />
    </form>
  </div>
</template>

<script>
export default {
  name: "PointProgramsActivateDeactivateProgramsContest.vue",

  props: {
    params: Object,
  },

  methods: {
    deactivateProgramContest: function () {
      const param = {
        programId: +this.params.programId,
        active: this.params.isActive === 1 ? 0 : 1,
      };
      console.log(param, "from activate store");
      this.$store
        .dispatch("adminPointPrograms/activateDeactivateProgramContest", param)
        .then((status) => {
          if (status) {
            // give message
            this.$store.dispatch("systemMessage/setMessage", {
              message:
                param.active === 0
                  ? "Your program is inactive. You can no longer add points to users using this program. Current reporting remains unaffected."
                  : "This program is now active again.",
            });

            //   update latest program in store
            this.$store.dispatch("adminPointPrograms/fetchProgramDetailsById", {
              programId: +param.programId,
            });

            // updating latest program list in store
            this.$store.dispatch("adminPointPrograms/fetchProgrammes", {
              allClientSelect: false,
              userType: this.getUserClients.userType
                ? this.getUserClients.userType
                : 0,
              clientIds:
                this.getUserClients.clients.lenth > 0
                  ? this.getUserClients.clients
                  : [+this.getUserClients.client],
            });

            // scroll to top
            this.scrollToTop();
          }
        })
        .catch(() => {
          console.log("error from activate deactivate component");
        });
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  computed: {
    getUserClients() {
      return this.$store.getters["user/getUserClients"];
    },
  },
};
</script>

<style>
</style>